// extracted by mini-css-extract-plugin
module.exports = {"alertModal":"styles_alertModal___oWUc","content":"styles_content__89KAS","header":"styles_header__NOomh","message":"styles_message__Ugaff","controls":"styles_controls__SXfOL"};